
import { defineComponent } from "vue";
import { useDisplayPaneStore } from "@/stores/ssaStore/displayPane";
import { usePresetsStore } from "@/stores/ssaStore/presets";
import { useActiveStore } from "@/stores/ssaStore/active";
import { storeToRefs } from "pinia";
import GradientImage from "./colorUtils/gradientImage.vue";
import EditGradients from "./colorUtils/editGradients.vue";
export default defineComponent({
	name: "color-map-selector",
	setup() {
		const displayPaneStore = useDisplayPaneStore();
		const presetStore = usePresetsStore();
		const { colorPresets, fixedColorPresets, colorScale } = storeToRefs(usePresetsStore());
		const { SSA_ACTIVE_REPRESENTATION_STATE: activeRepresentationState } = storeToRefs(
			useActiveStore()
		);
		const { SSA_SET_COLOR_SCALE: setColorScale } = usePresetsStore();

		return {
			fixedColorPresets,
			activeRepresentationState,
			colorPresets,
			colorScale,
			setColorScale,
			presetStore,
			displayPaneStore
		};
	},
	props: {
		categorical: {
			type: Boolean,
			default: false
		},
		tempConfig: {
			type: Object,
			default: (() => {
				return {};
			}) as any
		},
		fileName: {
			type: String,
			default: ""
		},
		value: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			searchTerm: "",
			editGradients: false
		};
	},
	computed: {
		selectedMap(): any {
			return this.tempConfig?.preset?.id;
		},
		continuous(): any {
			if (this.searchTerm == "") {
				return this.presetStore.colorPresets;
			} else {
				return this.presetStore.colorPresets.filter((item: any) => {
					return item.text.toLowerCase().indexOf(this.searchTerm) > -1;
				});
			}
		},
		continuousFixed(): any {
			if (this.searchTerm == "") {
				return this.presetStore.fixedColorPresets;
			} else {
				return this.presetStore.fixedColorPresets.filter((item: any) => {
					return item.text.toLowerCase().indexOf(this.searchTerm) > -1;
				});
			}
		}
	},
	methods: {
		updateColorMap() {
			if (this.colorScale.id == this.activeRepresentationState.coloring.preset.id) {
				this.setColorMap(this.colorScale);
			}
		},
		setColorMap(item: any) {
			this.setColorScale(item);
			this.$emit("update:value", item);
			this.displayPaneStore.SET_CONTINUOUS_COLOR_MAP(
				item.id,
				item,
				(this.tempConfig as any).layerIdentifier
			);
		}
	},
	components: {
		GradientImage,
		EditGradients
	}
});
